var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.getCss('border'), _vm.getCss('text'), {'csu-clickable': _vm.clickable}],style:(_vm.backgroundImageStyle),on:{"click":_vm.jumpLinkHandler}},[_c('span',[_vm._v(_vm._s(_vm.configurationData.btnText || ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }